module.exports = __webpack_public_path__ + "img/img_left_nav_person_hover.27bee404.svg";